// This file is auto-generated by @hey-api/openapi-ts

import { createClient, createConfig, type Options } from '@hey-api/client-axios';
import type {
  AddChatMessageV1ChatAddChatMessagePostData,
  AddChatMessageV1ChatAddChatMessagePostError,
  AddChatMessageV1ChatAddChatMessagePostResponse,
  AnswerToConversationV1ChatAnswerToConversationMainCategoryCategoryPostData,
  AnswerToConversationV1ChatAnswerToConversationMainCategoryCategoryPostError,
  AnswerToConversationV1ChatAnswerToConversationMainCategoryCategoryPostResponse,
  AnswerToTextV1ChatAnswerToTextPostData,
  AnswerToTextV1ChatAnswerToTextPostError,
  AnswerToTextV1ChatAnswerToTextPostResponse,
  DeleteTtsFilesV1FileTtsLangDeleteData,
  DeleteTtsFilesV1FileTtsLangDeleteError,
  DeleteTtsFilesV1FileTtsLangDeleteResponse,
  GenTtsV1GenTtsGetData,
  GenTtsV1GenTtsGetError,
  GenTtsV1GenTtsGetResponse,
  GetAllMeaningsV1WordInfoAllMeaningsGetData,
  GetAllMeaningsV1WordInfoAllMeaningsGetError,
  GetAllMeaningsV1WordInfoAllMeaningsGetResponse,
  GetAntonymsV1WordInfoAntonymsGetData,
  GetAntonymsV1WordInfoAntonymsGetError,
  GetAntonymsV1WordInfoAntonymsGetResponse,
  GetArticleV1FeedsSummaryTopicIdGetData,
  GetArticleV1FeedsSummaryTopicIdGetError,
  GetArticleV1FeedsSummaryTopicIdGetResponse,
  GetArticleV1KlexikonArticlesTitleGetData,
  GetArticleV1KlexikonArticlesTitleGetError,
  GetArticleV1KlexikonArticlesTitleGetResponse,
  GetArticleV1WordInfoArticleGetData,
  GetArticleV1WordInfoArticleGetError,
  GetArticleV1WordInfoArticleGetResponse,
  GetAutoTextV1AutoTextPostData,
  GetAutoTextV1AutoTextPostError,
  GetAutoTextV1AutoTextPostResponse,
  GetBaseWordV1WordInfoBaseWordGetData,
  GetBaseWordV1WordInfoBaseWordGetError,
  GetBaseWordV1WordInfoBaseWordGetResponse,
  GetBookContentV1BooksContentBookUrlGetData,
  GetBookContentV1BooksContentBookUrlGetError,
  GetBookContentV1BooksContentBookUrlGetResponse,
  GetBooksListV1BooksListGetData,
  GetBooksListV1BooksListGetError,
  GetBooksListV1BooksListGetResponse,
  GetCategoryV1CategoryCategoryTypeMainCategoryCategoryGetData,
  GetCategoryV1CategoryCategoryTypeMainCategoryCategoryGetError,
  GetCategoryV1CategoryCategoryTypeMainCategoryCategoryGetResponse,
  GetConfigV1ConfigGetError,
  GetConfigV1ConfigGetResponse,
  GetConjugationsV1WordInfoConjugationsGetData,
  GetConjugationsV1WordInfoConjugationsGetError,
  GetConjugationsV1WordInfoConjugationsGetResponse,
  GetConversationsV1CategoryConversationsMainCategoryCategoryGetData,
  GetConversationsV1CategoryConversationsMainCategoryCategoryGetError,
  GetConversationsV1CategoryConversationsMainCategoryCategoryGetResponse,
  GetDefinitionV1WordInfoDefinitionGetData,
  GetDefinitionV1WordInfoDefinitionGetError,
  GetDefinitionV1WordInfoDefinitionGetResponse,
  GetEmotionalExamplesV1WordInfoEmotionalExamplesGetData,
  GetEmotionalExamplesV1WordInfoEmotionalExamplesGetError,
  GetEmotionalExamplesV1WordInfoEmotionalExamplesGetResponse,
  GetEtymologyV1WordInfoEtymologyGetData,
  GetEtymologyV1WordInfoEtymologyGetError,
  GetEtymologyV1WordInfoEtymologyGetResponse,
  GetExampleSentenceV1WordInfoExampleSentencePostData,
  GetExampleSentenceV1WordInfoExampleSentencePostError,
  GetExampleSentenceV1WordInfoExampleSentencePostResponse,
  GetExampleV1WordInfoExampleGetData,
  GetExampleV1WordInfoExampleGetError,
  GetExampleV1WordInfoExampleGetResponse,
  GetExamplesV1WordInfoExamplesGetData,
  GetExamplesV1WordInfoExamplesGetError,
  GetExamplesV1WordInfoExamplesGetResponse,
  GetExtensionsV1WordInfoExtensionsGetData,
  GetExtensionsV1WordInfoExtensionsGetError,
  GetExtensionsV1WordInfoExtensionsGetResponse,
  GetFeedHealinesV1FeedsGetData,
  GetFeedHealinesV1FeedsGetError,
  GetFeedHealinesV1FeedsGetResponse,
  GetFunFactsV1FunFactsLangForeignGetData,
  GetFunFactsV1FunFactsLangForeignGetError,
  GetFunFactsV1FunFactsLangForeignGetResponse,
  GetGrammarChapterV1GrammarChapterGetData,
  GetGrammarChapterV1GrammarChapterGetError,
  GetGrammarChapterV1GrammarChapterGetResponse,
  GetGrammarMenuV1GrammarMenuGetData,
  GetGrammarMenuV1GrammarMenuGetError,
  GetGrammarMenuV1GrammarMenuGetResponse,
  GetGrammerV1WordInfoGrammerGetData,
  GetGrammerV1WordInfoGrammerGetError,
  GetGrammerV1WordInfoGrammerGetResponse,
  GetGrammerWordV1WordInfoGrammerWordGetData,
  GetGrammerWordV1WordInfoGrammerWordGetError,
  GetGrammerWordV1WordInfoGrammerWordGetResponse,
  GetHeadlineByIdV1FeedsIdGetData,
  GetHeadlineByIdV1FeedsIdGetError,
  GetHeadlineByIdV1FeedsIdGetResponse,
  GetImageSentenceV1WordInfoImageSentenceGetData,
  GetImageSentenceV1WordInfoImageSentenceGetError,
  GetImageSentenceV1WordInfoImageSentenceGetResponse,
  GetImageV1WordInfoImageGetData,
  GetImageV1WordInfoImageGetError,
  GetImageV1WordInfoImageGetResponse,
  GetImagesUnsplashV1WordInfoImagesGetData,
  GetImagesUnsplashV1WordInfoImagesGetError,
  GetImagesUnsplashV1WordInfoImagesGetResponse,
  GetJokesV1JokesGetData,
  GetJokesV1JokesGetError,
  GetJokesV1JokesGetResponse,
  GetLiveConversationByIdV1LiveConversationsConversationIdGetData,
  GetLiveConversationByIdV1LiveConversationsConversationIdGetError,
  GetLiveConversationByIdV1LiveConversationsConversationIdGetResponse,
  GetLiveConversationSessionV1LiveConversationsSessionsSessionIdGetData,
  GetLiveConversationSessionV1LiveConversationsSessionsSessionIdGetError,
  GetLiveConversationSessionV1LiveConversationsSessionsSessionIdGetResponse,
  GetLiveConversationsV1LiveConversationsGetError,
  GetLiveConversationsV1LiveConversationsGetResponse,
  GetLoadCountsV1ConfigLoadCountsGetData,
  GetLoadCountsV1ConfigLoadCountsGetError,
  GetLoadCountsV1ConfigLoadCountsGetResponse,
  GetMainTranslationsV1WordInfoMainTranslationsGetData,
  GetMainTranslationsV1WordInfoMainTranslationsGetError,
  GetMainTranslationsV1WordInfoMainTranslationsGetResponse,
  GetMappingsV1WordInfoMappingsGetData,
  GetMappingsV1WordInfoMappingsGetError,
  GetMappingsV1WordInfoMappingsGetResponse,
  GetMostCommonWordsV1WordInfoMostCommonWordsGetData,
  GetMostCommonWordsV1WordInfoMostCommonWordsGetError,
  GetMostCommonWordsV1WordInfoMostCommonWordsGetResponse,
  GetShortStoriesV1CourseStoriesGetData,
  GetShortStoriesV1CourseStoriesGetError,
  GetShortStoriesV1CourseStoriesGetResponse,
  GetSynonymsV1WordInfoSynonymsGetData,
  GetSynonymsV1WordInfoSynonymsGetError,
  GetSynonymsV1WordInfoSynonymsGetResponse,
  GetTeasersV1KlexikonTeasersGetData,
  GetTeasersV1KlexikonTeasersGetError,
  GetTeasersV1KlexikonTeasersGetResponse,
  GetTextCorrectionV1WriteCorrectPostData,
  GetTextCorrectionV1WriteCorrectPostError,
  GetTextCorrectionV1WriteCorrectPostResponse,
  GetTranslationSentenceV1WordInfoTranslationSentenceGetData,
  GetTranslationSentenceV1WordInfoTranslationSentenceGetError,
  GetTranslationSentenceV1WordInfoTranslationSentenceGetResponse,
  GetTranslationSentencesV1WordInfoTranslationSentencesPostData,
  GetTranslationSentencesV1WordInfoTranslationSentencesPostError,
  GetTranslationSentencesV1WordInfoTranslationSentencesPostResponse,
  GetTranslationV1WordInfoTranslationGetData,
  GetTranslationV1WordInfoTranslationGetError,
  GetTranslationV1WordInfoTranslationGetResponse,
  GetTranslationsV1WordInfoTranslationsPostData,
  GetTranslationsV1WordInfoTranslationsPostError,
  GetTranslationsV1WordInfoTranslationsPostResponse,
  GetVideoByIdV1VideosIdGetData,
  GetVideoByIdV1VideosIdGetError,
  GetVideoByIdV1VideosIdGetResponse,
  GetVideoByIdxV1VideosChannelChannelIdGetData,
  GetVideoByIdxV1VideosChannelChannelIdGetError,
  GetVideoByIdxV1VideosChannelChannelIdGetResponse,
  GetVocabularyV1VocabularyGetData,
  GetVocabularyV1VocabularyGetError,
  GetVocabularyV1VocabularyGetResponse,
  GetWordImageV1CourseWordImagePostData,
  GetWordImageV1CourseWordImagePostError,
  GetWordImageV1CourseWordImagePostResponse,
  GetWordValidationV1WordInfoWordValidationGetData,
  GetWordValidationV1WordInfoWordValidationGetError,
  GetWordValidationV1WordInfoWordValidationGetResponse,
  GetWriteTaskV1CategoryWriteMainCategoryCategoryGetData,
  GetWriteTaskV1CategoryWriteMainCategoryCategoryGetError,
  GetWriteTaskV1CategoryWriteMainCategoryCategoryGetResponse,
  PostCustomVocabularyV1CustomVocabularyPostData,
  PostCustomVocabularyV1CustomVocabularyPostError,
  PostCustomVocabularyV1CustomVocabularyPostResponse,
  ReturnAudioFileV1FileAudioLangExtQgetData,
  ReturnAudioFileV1FileAudioLangExtQgetError,
  ReturnAudioFileV1FileAudioLangExtQgetResponse,
  ReturnImageFileV1FileImageNameGetData,
  ReturnImageFileV1FileImageNameGetError,
  ReturnImageFileV1FileImageNameGetResponse,
  ReturnSoundFileV1FileSoundsNameGetData,
  ReturnSoundFileV1FileSoundsNameGetError,
  ReturnSoundFileV1FileSoundsNameGetResponse,
  SearchArticleV1FeedsSearchGetData,
  SearchArticleV1FeedsSearchGetError,
  SearchArticleV1FeedsSearchGetResponse,
  SearchTeasersV1KlexikonTeasersSearchGetData,
  SearchTeasersV1KlexikonTeasersSearchGetError,
  SearchTeasersV1KlexikonTeasersSearchGetResponse,
  SendEmailV1EmailSendPostData,
  SendEmailV1EmailSendPostError,
  SendEmailV1EmailSendPostResponse,
  SplitChineseSentenceV1SentencesSplitChineseSentencePostData,
  SplitChineseSentenceV1SentencesSplitChineseSentencePostError,
  SplitChineseSentenceV1SentencesSplitChineseSentencePostResponse,
  StartLiveConversationV1LiveConversationsConversationIdStartPostData,
  StartLiveConversationV1LiveConversationsConversationIdStartPostError,
  StartLiveConversationV1LiveConversationsConversationIdStartPostResponse,
  SummarizeMistakesV1ChatSummarizeMistakesPostData,
  SummarizeMistakesV1ChatSummarizeMistakesPostError,
  SummarizeMistakesV1ChatSummarizeMistakesPostResponse
} from './types.gen';

export const client = createClient(createConfig());

export class WordInfoService {
  /**
   *  Get Translations
   * Get translations for multiple words with caching.
   * Cache is based on all parameters being the same.
   */
  public static getTranslationsV1WordInfoTranslationsPost<ThrowOnError extends boolean = false>(
    options: Options<GetTranslationsV1WordInfoTranslationsPostData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      GetTranslationsV1WordInfoTranslationsPostResponse,
      GetTranslationsV1WordInfoTranslationsPostError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/word-info/translations'
    });
  }

  /**
   *  Get Translation Sentences
   * Get sentence translations for multiple words with caching.
   * Cache is based on all parameters being the same.
   */
  public static getTranslationSentencesV1WordInfoTranslationSentencesPost<
    ThrowOnError extends boolean = false
  >(options: Options<GetTranslationSentencesV1WordInfoTranslationSentencesPostData, ThrowOnError>) {
    return (options?.client ?? client).post<
      GetTranslationSentencesV1WordInfoTranslationSentencesPostResponse,
      GetTranslationSentencesV1WordInfoTranslationSentencesPostError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/word-info/translation-sentences'
    });
  }

  /**
   *  Get Translation
   */
  public static getTranslationV1WordInfoTranslationGet<ThrowOnError extends boolean = false>(
    options: Options<GetTranslationV1WordInfoTranslationGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetTranslationV1WordInfoTranslationGetResponse,
      GetTranslationV1WordInfoTranslationGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/word-info/translation'
    });
  }

  /**
   *  Get Word Validation
   */
  public static getWordValidationV1WordInfoWordValidationGet<ThrowOnError extends boolean = false>(
    options: Options<GetWordValidationV1WordInfoWordValidationGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetWordValidationV1WordInfoWordValidationGetResponse,
      GetWordValidationV1WordInfoWordValidationGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/word-info/word-validation'
    });
  }

  /**
   *  Get Translation Sentence
   */
  public static getTranslationSentenceV1WordInfoTranslationSentenceGet<
    ThrowOnError extends boolean = false
  >(options: Options<GetTranslationSentenceV1WordInfoTranslationSentenceGetData, ThrowOnError>) {
    return (options?.client ?? client).get<
      GetTranslationSentenceV1WordInfoTranslationSentenceGetResponse,
      GetTranslationSentenceV1WordInfoTranslationSentenceGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/word-info/translation-sentence'
    });
  }

  /**
   *  Get Image
   */
  public static getImageV1WordInfoImageGet<ThrowOnError extends boolean = false>(
    options: Options<GetImageV1WordInfoImageGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetImageV1WordInfoImageGetResponse,
      GetImageV1WordInfoImageGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/word-info/image'
    });
  }

  /**
   *  Get Example
   */
  public static getExampleV1WordInfoExampleGet<ThrowOnError extends boolean = false>(
    options: Options<GetExampleV1WordInfoExampleGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetExampleV1WordInfoExampleGetResponse,
      GetExampleV1WordInfoExampleGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/word-info/example'
    });
  }

  /**
   *  Get Examples
   */
  public static getExamplesV1WordInfoExamplesGet<ThrowOnError extends boolean = false>(
    options: Options<GetExamplesV1WordInfoExamplesGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetExamplesV1WordInfoExamplesGetResponse,
      GetExamplesV1WordInfoExamplesGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/word-info/examples'
    });
  }

  /**
   *  Get Emotional Examples
   */
  public static getEmotionalExamplesV1WordInfoEmotionalExamplesGet<
    ThrowOnError extends boolean = false
  >(options: Options<GetEmotionalExamplesV1WordInfoEmotionalExamplesGetData, ThrowOnError>) {
    return (options?.client ?? client).get<
      GetEmotionalExamplesV1WordInfoEmotionalExamplesGetResponse,
      GetEmotionalExamplesV1WordInfoEmotionalExamplesGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/word-info/emotional-examples'
    });
  }

  /**
   *  Get Images Unsplash
   */
  public static getImagesUnsplashV1WordInfoImagesGet<ThrowOnError extends boolean = false>(
    options: Options<GetImagesUnsplashV1WordInfoImagesGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetImagesUnsplashV1WordInfoImagesGetResponse,
      GetImagesUnsplashV1WordInfoImagesGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/word-info/images'
    });
  }

  /**
   *  Get Synonyms
   */
  public static getSynonymsV1WordInfoSynonymsGet<ThrowOnError extends boolean = false>(
    options: Options<GetSynonymsV1WordInfoSynonymsGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetSynonymsV1WordInfoSynonymsGetResponse,
      GetSynonymsV1WordInfoSynonymsGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/word-info/synonyms'
    });
  }

  /**
   *  Get Antonyms
   */
  public static getAntonymsV1WordInfoAntonymsGet<ThrowOnError extends boolean = false>(
    options: Options<GetAntonymsV1WordInfoAntonymsGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetAntonymsV1WordInfoAntonymsGetResponse,
      GetAntonymsV1WordInfoAntonymsGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/word-info/antonyms'
    });
  }

  /**
   *  Get Main Translations
   */
  public static getMainTranslationsV1WordInfoMainTranslationsGet<
    ThrowOnError extends boolean = false
  >(options: Options<GetMainTranslationsV1WordInfoMainTranslationsGetData, ThrowOnError>) {
    return (options?.client ?? client).get<
      GetMainTranslationsV1WordInfoMainTranslationsGetResponse,
      GetMainTranslationsV1WordInfoMainTranslationsGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/word-info/main-translations'
    });
  }

  /**
   *  Get Extensions
   */
  public static getExtensionsV1WordInfoExtensionsGet<ThrowOnError extends boolean = false>(
    options: Options<GetExtensionsV1WordInfoExtensionsGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetExtensionsV1WordInfoExtensionsGetResponse,
      GetExtensionsV1WordInfoExtensionsGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/word-info/extensions'
    });
  }

  /**
   *  Get Mappings
   */
  public static getMappingsV1WordInfoMappingsGet<ThrowOnError extends boolean = false>(
    options: Options<GetMappingsV1WordInfoMappingsGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetMappingsV1WordInfoMappingsGetResponse,
      GetMappingsV1WordInfoMappingsGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/word-info/mappings'
    });
  }

  /**
   *  Get Definition
   */
  public static getDefinitionV1WordInfoDefinitionGet<ThrowOnError extends boolean = false>(
    options: Options<GetDefinitionV1WordInfoDefinitionGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetDefinitionV1WordInfoDefinitionGetResponse,
      GetDefinitionV1WordInfoDefinitionGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/word-info/definition'
    });
  }

  /**
   *  Get Base Word
   */
  public static getBaseWordV1WordInfoBaseWordGet<ThrowOnError extends boolean = false>(
    options: Options<GetBaseWordV1WordInfoBaseWordGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetBaseWordV1WordInfoBaseWordGetResponse,
      GetBaseWordV1WordInfoBaseWordGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/word-info/base-word'
    });
  }

  /**
   *  Get Article
   */
  public static getArticleV1WordInfoArticleGet<ThrowOnError extends boolean = false>(
    options: Options<GetArticleV1WordInfoArticleGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetArticleV1WordInfoArticleGetResponse,
      GetArticleV1WordInfoArticleGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/word-info/article'
    });
  }

  /**
   *  Get Conjugations
   */
  public static getConjugationsV1WordInfoConjugationsGet<ThrowOnError extends boolean = false>(
    options: Options<GetConjugationsV1WordInfoConjugationsGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetConjugationsV1WordInfoConjugationsGetResponse,
      GetConjugationsV1WordInfoConjugationsGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/word-info/conjugations'
    });
  }

  /**
   *  Get Grammer
   */
  public static getGrammerV1WordInfoGrammerGet<ThrowOnError extends boolean = false>(
    options: Options<GetGrammerV1WordInfoGrammerGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetGrammerV1WordInfoGrammerGetResponse,
      GetGrammerV1WordInfoGrammerGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/word-info/grammer'
    });
  }

  /**
   *  Get Grammer Word
   */
  public static getGrammerWordV1WordInfoGrammerWordGet<ThrowOnError extends boolean = false>(
    options: Options<GetGrammerWordV1WordInfoGrammerWordGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetGrammerWordV1WordInfoGrammerWordGetResponse,
      GetGrammerWordV1WordInfoGrammerWordGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/word-info/grammer-word'
    });
  }

  /**
   *  Get Etymology
   */
  public static getEtymologyV1WordInfoEtymologyGet<ThrowOnError extends boolean = false>(
    options: Options<GetEtymologyV1WordInfoEtymologyGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetEtymologyV1WordInfoEtymologyGetResponse,
      GetEtymologyV1WordInfoEtymologyGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/word-info/etymology'
    });
  }

  /**
   *  Get All Meanings
   */
  public static getAllMeaningsV1WordInfoAllMeaningsGet<ThrowOnError extends boolean = false>(
    options: Options<GetAllMeaningsV1WordInfoAllMeaningsGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetAllMeaningsV1WordInfoAllMeaningsGetResponse,
      GetAllMeaningsV1WordInfoAllMeaningsGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/word-info/all-meanings'
    });
  }

  /**
   *  Get Image Sentence
   */
  public static getImageSentenceV1WordInfoImageSentenceGet<ThrowOnError extends boolean = false>(
    options: Options<GetImageSentenceV1WordInfoImageSentenceGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetImageSentenceV1WordInfoImageSentenceGetResponse,
      GetImageSentenceV1WordInfoImageSentenceGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/word-info/image-sentence'
    });
  }

  /**
   *  Get Most Common Words
   */
  public static getMostCommonWordsV1WordInfoMostCommonWordsGet<
    ThrowOnError extends boolean = false
  >(options: Options<GetMostCommonWordsV1WordInfoMostCommonWordsGetData, ThrowOnError>) {
    return (options?.client ?? client).get<
      GetMostCommonWordsV1WordInfoMostCommonWordsGetResponse,
      GetMostCommonWordsV1WordInfoMostCommonWordsGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/word-info/most-common-words'
    });
  }

  /**
   *  Get Example Sentence
   */
  public static getExampleSentenceV1WordInfoExampleSentencePost<
    ThrowOnError extends boolean = false
  >(options: Options<GetExampleSentenceV1WordInfoExampleSentencePostData, ThrowOnError>) {
    return (options?.client ?? client).post<
      GetExampleSentenceV1WordInfoExampleSentencePostResponse,
      GetExampleSentenceV1WordInfoExampleSentencePostError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/word-info/example-sentence'
    });
  }
}

export class FileService {
  /**
   * Return Audio File
   */
  public static returnAudioFileV1FileAudioLangExtQGet<ThrowOnError extends boolean = false>(
    options: Options<ReturnAudioFileV1FileAudioLangExtQgetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ReturnAudioFileV1FileAudioLangExtQgetResponse,
      ReturnAudioFileV1FileAudioLangExtQgetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/file/audio/{lang}/{ext}/{q}'
    });
  }

  /**
   * Return Image File
   */
  public static returnImageFileV1FileImageNameGet<ThrowOnError extends boolean = false>(
    options: Options<ReturnImageFileV1FileImageNameGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ReturnImageFileV1FileImageNameGetResponse,
      ReturnImageFileV1FileImageNameGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/file/image/{name}'
    });
  }

  /**
   * Return Sound File
   */
  public static returnSoundFileV1FileSoundsNameGet<ThrowOnError extends boolean = false>(
    options: Options<ReturnSoundFileV1FileSoundsNameGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ReturnSoundFileV1FileSoundsNameGetResponse,
      ReturnSoundFileV1FileSoundsNameGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/file/sounds/{name}'
    });
  }

  /**
   * Delete Tts Files
   * Delete all TTS files for a specific language.
   *
   * Args:
   * lang: The language code for which to delete TTS files
   *
   * Returns:
   * A message indicating how many files were deleted
   */
  public static deleteTtsFilesV1FileTtsLangDelete<ThrowOnError extends boolean = false>(
    options: Options<DeleteTtsFilesV1FileTtsLangDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      DeleteTtsFilesV1FileTtsLangDeleteResponse,
      DeleteTtsFilesV1FileTtsLangDeleteError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/file/tts/{lang}'
    });
  }
}

export class SentencesService {
  /**
   * Split Chinese Sentence
   */
  public static splitChineseSentenceV1SentencesSplitChineseSentencePost<
    ThrowOnError extends boolean = false
  >(options: Options<SplitChineseSentenceV1SentencesSplitChineseSentencePostData, ThrowOnError>) {
    return (options?.client ?? client).post<
      SplitChineseSentenceV1SentencesSplitChineseSentencePostResponse,
      SplitChineseSentenceV1SentencesSplitChineseSentencePostError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/sentences/split-chinese-sentence'
    });
  }
}

export class ConfigService {
  /**
   * Get Config
   */
  public static getConfigV1ConfigGet<ThrowOnError extends boolean = false>(
    options?: Options<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetConfigV1ConfigGetResponse,
      GetConfigV1ConfigGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/config/'
    });
  }

  /**
   * Get Load Counts
   */
  public static getLoadCountsV1ConfigLoadCountsGet<ThrowOnError extends boolean = false>(
    options: Options<GetLoadCountsV1ConfigLoadCountsGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetLoadCountsV1ConfigLoadCountsGetResponse,
      GetLoadCountsV1ConfigLoadCountsGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/config/load-counts'
    });
  }
}

export class FeedsService {
  /**
   *  Get Feed Healines
   */
  public static getFeedHealinesV1FeedsGet<ThrowOnError extends boolean = false>(
    options: Options<GetFeedHealinesV1FeedsGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetFeedHealinesV1FeedsGetResponse,
      GetFeedHealinesV1FeedsGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/feeds/'
    });
  }

  /**
   *  Search Article
   * Return the first FeedArticle whose title, created_content, or created_summary
   * contains `q` (case-insensitive). If no topic is provided, searches across all topics.
   */
  public static searchArticleV1FeedsSearchGet<ThrowOnError extends boolean = false>(
    options: Options<SearchArticleV1FeedsSearchGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      SearchArticleV1FeedsSearchGetResponse,
      SearchArticleV1FeedsSearchGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/feeds/search'
    });
  }

  /**
   *  Get Headline By Id
   */
  public static getHeadlineByIdV1FeedsIdGet<ThrowOnError extends boolean = false>(
    options: Options<GetHeadlineByIdV1FeedsIdGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetHeadlineByIdV1FeedsIdGetResponse,
      GetHeadlineByIdV1FeedsIdGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/feeds/{id}'
    });
  }

  /**
   *  Get Article
   */
  public static getArticleV1FeedsSummaryTopicIdGet<ThrowOnError extends boolean = false>(
    options: Options<GetArticleV1FeedsSummaryTopicIdGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetArticleV1FeedsSummaryTopicIdGetResponse,
      GetArticleV1FeedsSummaryTopicIdGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/feeds/summary/{topic}/{id}'
    });
  }
}

export class VideosService {
  /**
   *  Get Video By Idx
   */
  public static getVideoByIdxV1VideosChannelChannelIdGet<ThrowOnError extends boolean = false>(
    options: Options<GetVideoByIdxV1VideosChannelChannelIdGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetVideoByIdxV1VideosChannelChannelIdGetResponse,
      GetVideoByIdxV1VideosChannelChannelIdGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/videos/channel/{channel_id}'
    });
  }

  /**
   *  Get Video By Id
   */
  public static getVideoByIdV1VideosIdGet<ThrowOnError extends boolean = false>(
    options: Options<GetVideoByIdV1VideosIdGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetVideoByIdV1VideosIdGetResponse,
      GetVideoByIdV1VideosIdGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/videos/{id}'
    });
  }
}

export class KlexikonService {
  /**
   *  Get Teasers
   */
  public static getTeasersV1KlexikonTeasersGet<ThrowOnError extends boolean = false>(
    options: Options<GetTeasersV1KlexikonTeasersGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetTeasersV1KlexikonTeasersGetResponse,
      GetTeasersV1KlexikonTeasersGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/klexikon/teasers'
    });
  }

  /**
   *  Search Teasers
   */
  public static searchTeasersV1KlexikonTeasersSearchGet<ThrowOnError extends boolean = false>(
    options: Options<SearchTeasersV1KlexikonTeasersSearchGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      SearchTeasersV1KlexikonTeasersSearchGetResponse,
      SearchTeasersV1KlexikonTeasersSearchGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/klexikon/teasers/search'
    });
  }

  /**
   *  Get Article
   */
  public static getArticleV1KlexikonArticlesTitleGet<ThrowOnError extends boolean = false>(
    options: Options<GetArticleV1KlexikonArticlesTitleGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetArticleV1KlexikonArticlesTitleGetResponse,
      GetArticleV1KlexikonArticlesTitleGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/klexikon/articles/{title}'
    });
  }
}

export class BooksService {
  /**
   * Get Books List
   */
  public static getBooksListV1BooksListGet<ThrowOnError extends boolean = false>(
    options: Options<GetBooksListV1BooksListGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetBooksListV1BooksListGetResponse,
      GetBooksListV1BooksListGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/books/list'
    });
  }

  /**
   * Get Book Content
   */
  public static getBookContentV1BooksContentBookUrlGet<ThrowOnError extends boolean = false>(
    options: Options<GetBookContentV1BooksContentBookUrlGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetBookContentV1BooksContentBookUrlGetResponse,
      GetBookContentV1BooksContentBookUrlGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/books/content/{book_url}'
    });
  }
}

export class ChatService {
  /**
   * Answer To Text
   */
  public static answerToTextV1ChatAnswerToTextPost<ThrowOnError extends boolean = false>(
    options: Options<AnswerToTextV1ChatAnswerToTextPostData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      AnswerToTextV1ChatAnswerToTextPostResponse,
      AnswerToTextV1ChatAnswerToTextPostError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/chat/answer-to-text'
    });
  }

  /**
   * Add Chat Message
   */
  public static addChatMessageV1ChatAddChatMessagePost<ThrowOnError extends boolean = false>(
    options: Options<AddChatMessageV1ChatAddChatMessagePostData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      AddChatMessageV1ChatAddChatMessagePostResponse,
      AddChatMessageV1ChatAddChatMessagePostError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/chat/add-chat-message'
    });
  }

  /**
   * Answer To Conversation
   */
  public static answerToConversationV1ChatAnswerToConversationMainCategoryCategoryPost<
    ThrowOnError extends boolean = false
  >(
    options: Options<
      AnswerToConversationV1ChatAnswerToConversationMainCategoryCategoryPostData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).post<
      AnswerToConversationV1ChatAnswerToConversationMainCategoryCategoryPostResponse,
      AnswerToConversationV1ChatAnswerToConversationMainCategoryCategoryPostError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/chat/answer-to-conversation/{main_category}/{category}'
    });
  }

  /**
   * Summarize Mistakes
   */
  public static summarizeMistakesV1ChatSummarizeMistakesPost<ThrowOnError extends boolean = false>(
    options: Options<SummarizeMistakesV1ChatSummarizeMistakesPostData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      SummarizeMistakesV1ChatSummarizeMistakesPostResponse,
      SummarizeMistakesV1ChatSummarizeMistakesPostError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/chat/summarize-mistakes'
    });
  }
}

export class CategoryService {
  /**
   * Get Conversations
   */
  public static getConversationsV1CategoryConversationsMainCategoryCategoryGet<
    ThrowOnError extends boolean = false
  >(
    options: Options<
      GetConversationsV1CategoryConversationsMainCategoryCategoryGetData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).get<
      GetConversationsV1CategoryConversationsMainCategoryCategoryGetResponse,
      GetConversationsV1CategoryConversationsMainCategoryCategoryGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/category/conversations/{main_category}/{category}'
    });
  }

  /**
   *  Get Write Task
   */
  public static getWriteTaskV1CategoryWriteMainCategoryCategoryGet<
    ThrowOnError extends boolean = false
  >(options: Options<GetWriteTaskV1CategoryWriteMainCategoryCategoryGetData, ThrowOnError>) {
    return (options?.client ?? client).get<
      GetWriteTaskV1CategoryWriteMainCategoryCategoryGetResponse,
      GetWriteTaskV1CategoryWriteMainCategoryCategoryGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/category/write/{main_category}/{category}'
    });
  }

  /**
   * Get Category
   */
  public static getCategoryV1CategoryCategoryTypeMainCategoryCategoryGet<
    ThrowOnError extends boolean = false
  >(options: Options<GetCategoryV1CategoryCategoryTypeMainCategoryCategoryGetData, ThrowOnError>) {
    return (options?.client ?? client).get<
      GetCategoryV1CategoryCategoryTypeMainCategoryCategoryGetResponse,
      GetCategoryV1CategoryCategoryTypeMainCategoryCategoryGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/category/{category_type}/{main_category}/{category}'
    });
  }
}

export class EmailService {
  /**
   *  Send Email
   * Send a email.
   */
  public static sendEmailV1EmailSendPost<ThrowOnError extends boolean = false>(
    options: Options<SendEmailV1EmailSendPostData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      SendEmailV1EmailSendPostResponse,
      SendEmailV1EmailSendPostError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/email/send'
    });
  }
}

export class AutoTextService {
  /**
   * Get Auto Text
   */
  public static getAutoTextV1AutoTextPost<ThrowOnError extends boolean = false>(
    options: Options<GetAutoTextV1AutoTextPostData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      GetAutoTextV1AutoTextPostResponse,
      GetAutoTextV1AutoTextPostError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/auto-text/'
    });
  }
}

export class WriteService {
  /**
   *  Get Text Correction
   */
  public static getTextCorrectionV1WriteCorrectPost<ThrowOnError extends boolean = false>(
    options: Options<GetTextCorrectionV1WriteCorrectPostData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      GetTextCorrectionV1WriteCorrectPostResponse,
      GetTextCorrectionV1WriteCorrectPostError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/write/correct'
    });
  }
}

export class GenTtsService {
  /**
   *  Gen Tts
   */
  public static genTtsV1GenTtsGet<ThrowOnError extends boolean = false>(
    options: Options<GenTtsV1GenTtsGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GenTtsV1GenTtsGetResponse,
      GenTtsV1GenTtsGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/gen-tts/'
    });
  }
}

export class GrammarService {
  /**
   * Get Grammar Menu
   * Get the grammar menu for a specific language and language level.
   *
   * Args:
   * lang: The language to get the grammar menu for
   * lang_level: The language level (A1-A2, B1-B2, or C1-C2)
   *
   * Returns:
   * GrammerMenuRes: The grammar menu with chapters and subchapters
   */
  public static getGrammarMenuV1GrammarMenuGet<ThrowOnError extends boolean = false>(
    options: Options<GetGrammarMenuV1GrammarMenuGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetGrammarMenuV1GrammarMenuGetResponse,
      GetGrammarMenuV1GrammarMenuGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/grammar/menu'
    });
  }

  /**
   * Get Grammar Chapter
   * Get a specific grammar chapter for a language, language level, and chapter number.
   *
   * Args:
   * lang: The language to get the grammar chapter for
   * lang_level: The language level (A1-A2, B1-B2, or C1-C2)
   * chapter_number: The chapter number (e.g., "1", "1.1", "2.3")
   *
   * Returns:
   * GrammarLessonRes: The complete grammar lesson with detailed content
   */
  public static getGrammarChapterV1GrammarChapterGet<ThrowOnError extends boolean = false>(
    options: Options<GetGrammarChapterV1GrammarChapterGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetGrammarChapterV1GrammarChapterGetResponse,
      GetGrammarChapterV1GrammarChapterGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/grammar/chapter'
    });
  }
}

export class CourseService {
  /**
   *  Get Word Image
   * Return the image filename for a given word and context sentence.
   *
   * Looks up the concept_id derived from the word+context in the language's images.json.
   * Returns 404 if no image exists for that concept.
   */
  public static getWordImageV1CourseWordImagePost<ThrowOnError extends boolean = false>(
    options: Options<GetWordImageV1CourseWordImagePostData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      GetWordImageV1CourseWordImagePostResponse,
      GetWordImageV1CourseWordImagePostError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/course/word-image'
    });
  }

  /**
   *  Get Short Stories
   */
  public static getShortStoriesV1CourseStoriesGet<ThrowOnError extends boolean = false>(
    options: Options<GetShortStoriesV1CourseStoriesGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetShortStoriesV1CourseStoriesGetResponse,
      GetShortStoriesV1CourseStoriesGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/course/stories'
    });
  }
}

export class FunFactsService {
  /**
   * Get Fun Facts
   */
  public static getFunFactsV1FunFactsLangForeignGet<ThrowOnError extends boolean = false>(
    options: Options<GetFunFactsV1FunFactsLangForeignGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetFunFactsV1FunFactsLangForeignGetResponse,
      GetFunFactsV1FunFactsLangForeignGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/fun-facts/{lang_foreign}'
    });
  }
}

export class VocabularyService {
  /**
   * Get Vocabulary
   */
  public static getVocabularyV1VocabularyGet<ThrowOnError extends boolean = false>(
    options: Options<GetVocabularyV1VocabularyGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetVocabularyV1VocabularyGetResponse,
      GetVocabularyV1VocabularyGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/vocabulary'
    });
  }
}

export class CustomVocabularyService {
  /**
   * Post Custom Vocabulary
   */
  public static postCustomVocabularyV1CustomVocabularyPost<ThrowOnError extends boolean = false>(
    options: Options<PostCustomVocabularyV1CustomVocabularyPostData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      PostCustomVocabularyV1CustomVocabularyPostResponse,
      PostCustomVocabularyV1CustomVocabularyPostError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/custom-vocabulary'
    });
  }
}

export class JokesService {
  /**
   * Get Jokes
   */
  public static getJokesV1JokesGet<ThrowOnError extends boolean = false>(
    options: Options<GetJokesV1JokesGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetJokesV1JokesGetResponse,
      GetJokesV1JokesGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/jokes'
    });
  }
}

export class LiveConversationsService {
  /**
   * Get Live Conversations
   */
  public static getLiveConversationsV1LiveConversationsGet<ThrowOnError extends boolean = false>(
    options?: Options<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetLiveConversationsV1LiveConversationsGetResponse,
      GetLiveConversationsV1LiveConversationsGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/live-conversations'
    });
  }

  /**
   * Get Live Conversation By Id
   */
  public static getLiveConversationByIdV1LiveConversationsConversationIdGet<
    ThrowOnError extends boolean = false
  >(
    options: Options<GetLiveConversationByIdV1LiveConversationsConversationIdGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetLiveConversationByIdV1LiveConversationsConversationIdGetResponse,
      GetLiveConversationByIdV1LiveConversationsConversationIdGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/live-conversations/{conversation_id}'
    });
  }

  /**
   * Start Live Conversation
   */
  public static startLiveConversationV1LiveConversationsConversationIdStartPost<
    ThrowOnError extends boolean = false
  >(
    options: Options<
      StartLiveConversationV1LiveConversationsConversationIdStartPostData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).post<
      StartLiveConversationV1LiveConversationsConversationIdStartPostResponse,
      StartLiveConversationV1LiveConversationsConversationIdStartPostError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/live-conversations/{conversation_id}/start'
    });
  }

  /**
   * Get Live Conversation Session
   */
  public static getLiveConversationSessionV1LiveConversationsSessionsSessionIdGet<
    ThrowOnError extends boolean = false
  >(
    options: Options<
      GetLiveConversationSessionV1LiveConversationsSessionsSessionIdGetData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).get<
      GetLiveConversationSessionV1LiveConversationsSessionsSessionIdGetResponse,
      GetLiveConversationSessionV1LiveConversationsSessionsSessionIdGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/live-conversations/sessions/{session_id}'
    });
  }
}
